import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetDeclaracionJuradaCeseActividadObjetivaAByID = {
  status: number | null;
  statusText: string | null;
};

const useGetDeclaracionJuradaCeseActividadObjetivaAByID = () => {
  const [loadingGetDeclaracionJuradaCeseActividadObjetivaAByID, setLoadingDeclaracionJuradaCeseActividadObjetivaAByID] = useState(false);
  const [successGetDeclaracionJuradaCeseActividadObjetivaAByID, setSuccessDeclaracionJuradaCeseActividadObjetivaAByID] = useState(false);
  const [errorGetDeclaracionJuradaCeseActividadObjetivaAByID, setErrorDeclaracionJuradaCeseActividadObjetivaAByID] = useState<any>(null);
  const [dataGetDeclaracionJuradaCeseActividadObjetivaAByID, setDataDeclaracionJuradaCeseActividadObjetivaA] = useState<any>(null);

  const [statusGetDeclaracionJuradaCeseActividadObjetivaAByID, setStatusGetDeclaracionJuradaCeseActividadObjetivaAByID] =
    useState<StatusGetDeclaracionJuradaCeseActividadObjetivaAByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getDeclaracionJuradaCeseActividadObjetivaAByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingDeclaracionJuradaCeseActividadObjetivaAByID(true);
    setSuccessDeclaracionJuradaCeseActividadObjetivaAByID(false);
    setErrorDeclaracionJuradaCeseActividadObjetivaAByID(null);

    try {
      const res = await apiRecord.getSolicitudDeclaracionJuradaObjetivaByID(userId, prestacionId, id);

      setStatusGetDeclaracionJuradaCeseActividadObjetivaAByID({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessDeclaracionJuradaCeseActividadObjetivaAByID(true);
      setDataDeclaracionJuradaCeseActividadObjetivaA(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetDeclaracionJuradaCeseActividadObjetivaAByID({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorDeclaracionJuradaCeseActividadObjetivaAByID(err);
      console.error("Error en getDeclaracionJuradaCeseActividadObjetivaAByID:", err);

      throw err;

    } finally {
      setLoadingDeclaracionJuradaCeseActividadObjetivaAByID(false);
    }
  };

  return {
    getDeclaracionJuradaCeseActividadObjetivaAByID,
    loadingGetDeclaracionJuradaCeseActividadObjetivaAByID,
    successGetDeclaracionJuradaCeseActividadObjetivaAByID,
    errorGetDeclaracionJuradaCeseActividadObjetivaAByID,
    dataGetDeclaracionJuradaCeseActividadObjetivaAByID,
    statusGetDeclaracionJuradaCeseActividadObjetivaAByID
  };
};

export default useGetDeclaracionJuradaCeseActividadObjetivaAByID;
